import React, { useContext, useEffect, useState } from "react";
import LoaderBlock from "shared/loader/LoaderBlock";
import { pauseRestaurant, getRestaurantStatus } from "services/api/kitchen";
import UserContext from "store/user-context";
import toastify from "shared/toastr";
import { RoleType } from "constants/roleType";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Datetime from "react-datetime";
import moment from "moment";

const PauseRestaurant = (props) => {
  const [isLoading, setisLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [pausedUntil, setPausedUntil] = useState();
  const userCtx = useContext(UserContext);
  const userRole = userCtx.userRole;
  const isEdit =
    userRole === RoleType.ADMIN ||
    userRole === RoleType.ADMIN_STAFF ||
    userRole === RoleType.KITCHEN_OWNER;

  const validationSchema = Yup.object().shape({
    status: Yup.boolean(),
    reason: Yup.string().nullable(),
  });

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isValid },
  } = methods;

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = async () => {
    setisLoading(true);
    await getRestaurantStatus(props?.kitchen?.id)
      .then((res) => {
        const data = res.data;
        reset({
          status: data?.isPaused,
          reason: data?.reason,
        });
        setPausedUntil(data?.pausedUntil);
        setStatus(data?.isPaused);
        setisLoading(false);
      })
      .catch(() => {
        setisLoading(false);
      });
  };

  const onSubmit = async (data) => {
    const model = {
      kitchenId: props?.kitchen?.id,
      isPaused: data?.status,
      pausedUntil: data?.status === true ? pausedUntil : null,
      reason: data?.reason,
    };
    setisLoading(true);
    await pauseRestaurant(model)
      .then((res) => {
        toastify("success", res.message);
        getStatus();
      })
      .catch((e) => {
        toastify("error", e.message);
        setisLoading(false);
      });
  };

  const validStart = (current) => {
    const yesterday = moment().subtract(1, "day");
    return current.isAfter(yesterday);
  };

  const statusChange = (evt) => {
    setStatus(evt.target.checked);
    setPausedUntil(null);
    setValue("reason", null);
    if (evt.target.checked === false) {
      const data = {
        status: false,
      };
      onSubmit(data);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="details__wrapper">
        {isLoading ? (
          <LoaderBlock />
        ) : (
          <div className="details__wrapper__inner">
            <div className="form-row no-gutters">
              <div className="detailCard d-flex align-items-center mb-3 pb-0">
                <h5 className="mr-3 mb-0">Pause Restaurant</h5>
                <div className="switches">
                  <label className="switch">
                    <input
                      type="checkbox"
                      {...register("status")}
                      onChange={statusChange}
                      disabled={!isEdit}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>

              {status === true && (
                <>
                  <div className="col-md-12 mb-3 pb-3 px-0">
                    <label htmlFor="to">
                      Paused Until<span className="mendatory">*</span>
                    </label>
                    <Datetime
                      inputProps={{
                        placeholder: "MM/DD/YYYY HH:mm",
                      }}
                      isValidDate={validStart}
                      onChange={(date) => setPausedUntil(date)}
                      timeFormat="HH:mm:ss"
                      timeConstraints={{
                        hours: { min: 0, max: 23 },
                      }}
                      value={pausedUntil}
                    />
                    {status === true && !pausedUntil && (
                      <div className="invalid-feedback d-block">
                        Please select date time
                      </div>
                    )}
                  </div>
                  <div className="col-md-12 mb-3 pb-3">
                    <label htmlFor="reason"> Reason</label>
                    <textarea
                      id="reason"
                      placeholder="Provide reason"
                      style={{ minHeight: "90px" }}
                      className={`form-control ${
                        errors.name ? "is-invalid" : ""
                      }`}
                      {...register("reason")}
                      maxLength="500"
                      rows="3"
                    ></textarea>
                    {errors?.reason?.message && (
                      <div className="invalid-feedback d-block">
                        {errors?.reason?.message}
                      </div>
                    )}
                  </div>
                </>
              )}
              {isEdit && status === true && (
                <div className="button_wrapper">
                  <button
                    className="btn apply_btn"
                    disabled={
                      isLoading || !isValid || (status === true && !pausedUntil)
                    }
                  >
                    Apply
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default PauseRestaurant;
